export const PageTypes = {
  attachment: 'attachment',
  bodymap: 'bodymap',
  canvas: 'canvas',
  customform: 'customform',
  image: 'image',
  labtest: 'labtest',
  medicalcertificate: 'medicalcertificate',
  medicalclearance: 'medicalclearance',
  medicalhistory: 'medicalhistory',
  prescription: 'prescription',
  text: 'text',
  __labresults: '__labresults',
  labpage: 'labpage',
  educ: 'educ',
};

export const TitleHeaders = {
  attachment: 'Attachment',
  bodymap: 'Body Map',
  canvas: 'Canvas',
  customform: 'Form',
  image: 'Image',
  labtest: 'Lab Request',
  medicalcertificate: 'Medical Certificate',
  medicalclearance: 'Medical Clearance  ',
  medicalhistory: 'Medical History',
  prescription: 'Prescription',
  text: 'Text',
  [PageTypes.__labresults]: 'Lab Test Results',
};

export const Title = {
  attachment: 'Attachment',
  bodymap: 'Body Map',
  canvas: 'Canvas',
  customform: 'Form',
  image: 'Image',
  labtest: 'Lab Request',
  labpage: 'Lab Result',
  medicalcertificate: 'Certificate',
  medicalclearance: 'Clearance  ',
  medicalhistory: 'Medical History',
  prescription: 'Prescription',
  text: 'Text',
}